export const PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})/;
export const WEAK_PASSWORD_MESSAGE = 'Passwords should be 8 to 64 characters with at least one of each of the following: lowercase letters, uppercase letters, numbers, and symbols.';
export const PRIVACY_POLICY_LINK = 'https://www.korioclinical.com/privacy-policy';
